import { useState, useEffect } from 'react';
import { studentAPI } from '../../utils/api';
import { NavLink } from 'react-router-dom';
import Sidebar from './Sidebar';

const BOTTOM_NAV = [
  { path: '/dashboard', icon: '🏠', label: 'Home' },
  { path: '/subjects', icon: '📚', label: 'Subjects' },
  { path: '/revisions', icon: '📅', label: 'Revisions' },
  { path: '/progress', icon: '📊', label: 'Progress' },
  { path: '/settings', icon: '⚙️', label: 'Settings' },
];

const AppShell = ({ children, revisionCount = 0, streak = 0 }) => {
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);
  const [showNotif, setShowNotif] = useState(false);

  useEffect(() => { loadNotifications(); }, []);

  const loadNotifications = async () => {
    try {
      const res = await studentAPI.getNotifications();
      setNotifications(res.data.data?.notifications || []);
      setUnread(res.data.data?.unread || 0);
    } catch {}
  };

  const handleBellClick = async () => {
    setShowNotif(!showNotif);
    if (unread > 0) {
      try {
        await studentAPI.markNotificationsRead();
        setUnread(0);
      } catch {}
    }
  };
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-shell">
      <div className="sidebar-desktop">
        <Sidebar revisionCount={revisionCount} streak={streak} />
      </div>

      {sidebarOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 999, display: 'flex' }}>
          <div style={{ width: '260px', height: '100%', overflowY: 'auto', zIndex: 1000, flexShrink: 0, background: 'var(--brand-secondary)' }}>
            <div className="mobile-sidebar-overlay" style={{ height: '100%' }}>
              <Sidebar revisionCount={revisionCount} streak={streak} onClose={() => setSidebarOpen(false)} />
            </div>
          </div>
          <div style={{ flex: 1, background: 'rgba(0,0,0,0.5)' }} onClick={() => setSidebarOpen(false)} />
        </div>
      )}

      <div className="main-content">
        <div className="mobile-topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ width: '30px', height: '30px', background: 'var(--brand-primary)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 900, color: 'white', fontFamily: "'Baloo 2', cursive" }}>G</div>
            <span style={{ fontFamily: "'Baloo 2', cursive", fontSize: '16px', fontWeight: 800, color: 'var(--brand-primary)' }}>MyPersonalGuruji</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ position: 'relative' }} onClick={handleBellClick}>
              <button style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: 'white', padding: '4px' }}>🔔</button>
              {unread > 0 && <div style={{ position: 'absolute', top: '0', right: '0', width: '16px', height: '16px', borderRadius: '50%', background: '#FF6B00', color: 'white', fontSize: '9px', fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{unread}</div>}
            </div>
            <button onClick={() => setSidebarOpen(true)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: 'white', padding: '4px 8px' }}>☰</button>
          </div>

          {showNotif && (
            <div style={{ position: 'absolute', top: '50px', right: '10px', width: '300px', background: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', zIndex: 500, overflow: 'hidden' }}>
              <div style={{ padding: '12px 16px', borderBottom: '1px solid #E2E8F0', fontSize: '13px', fontWeight: 800 }}>Notifications</div>
              {notifications.length === 0 ? (
                <div style={{ padding: '20px', textAlign: 'center', color: '#94A3B8', fontSize: '13px' }}>No notifications yet</div>
              ) : notifications.map((n, i) => (
                <div key={i} style={{ padding: '12px 16px', borderBottom: '1px solid #F1F5F9', background: n.is_read ? 'white' : '#F3F0FF' }}>
                  <div style={{ fontSize: '12px', fontWeight: 700, color: '#1A1A2E', marginBottom: '2px' }}>{n.title}</div>
                  <div style={{ fontSize: '11px', color: '#64748B' }}>{n.message}</div>
                  <div style={{ fontSize: '10px', color: '#94A3B8', marginTop: '4px' }}>{new Date(n.created_at).toLocaleDateString('en-IN')}</div>
                </div>
              ))}
            </div>
          )}
        </div>

        {children}

        <div className="bottom-nav">
          {BOTTOM_NAV.map(item => (
            <NavLink key={item.path} to={item.path}
              style={({ isActive }) => ({
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px',
                padding: '6px 4px', textDecoration: 'none', flex: 1,
                color: isActive ? 'var(--brand-primary)' : 'var(--muted)',
                fontSize: '13px', fontWeight: isActive ? 800 : 600,
              })}>
              <span style={{ fontSize: '20px', lineHeight: 1 }}>{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppShell;
